import * as v from "valibot";
import { createFileRoute } from "@tanstack/react-router";
import { site } from "../config";
import { localisedLinks } from "../seo";

const searchParamsSchema = v.object({
  content: v.optional(v.string()),
});

export const Route = createFileRoute("/$locale/$currency/help")({
  component: () => null,
  validateSearch: searchParamsSchema,
  head: ({ match, params }) => ({
    meta: [
      { title: `Help - ${site.title}` },
      {
        name: "description",
        content: "Find answers to common questions and get support",
      },
    ],
    links: localisedLinks(match.pathname, params.locale, params.currency),
  }),
});
